import { render, staticRenderFns } from "./StepTypeSelection.vue?vue&type=template&id=a564e9c0"
import script from "./StepTypeSelection.vue?vue&type=script&lang=js"
export * from "./StepTypeSelection.vue?vue&type=script&lang=js"
import style0 from "./StepTypeSelection.vue?vue&type=style&index=0&id=a564e9c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports